class MobileNavToggle extends HTMLElement {
	constructor() {
		super()
		this.menuDrawer = document.querySelector('.f-drawer-mobile-nav')
		this.addEventListener('click', this.openNav.bind(this))

		if (this.menuDrawer) {
			this.menuDrawer.addEventListener('close', () => {
				this.setAttribute('aria-expanded', 'false')
			})
		}
	}

	disconnectedCallback() {
		this.removeEventListener('click', this.openNav.bind(this))
	}

	openNav() {
		if (this.menuDrawer) {
			this.menuDrawer.openDrawer()
			this.setAttribute('aria-expanded', 'true')
		}
	}
}
customElements.define('mobile-nav-toggle', MobileNavToggle)


  // Open all mobile nav items with children by default
  window.addEventListener('load', function () {
    var mobileNav = document.getElementById('Mobile-Nav');
    if (!mobileNav) return;

    // Find all collapsible tabs under items that have children
    var tabs = mobileNav.querySelectorAll('.f-mobile-nav__item--has-child collapsible-tab');

    tabs.forEach(function (tab) {
      var trigger = tab.querySelector('[data-trigger]');
      if (!trigger) return;

      // If it's already expanded, don't touch it
      if (trigger.getAttribute('aria-expanded') === 'true') return;

      // Use the component's own toggle logic by clicking the trigger
      trigger.click();
    });
  });

